import type { LinkPricingApi, LinkPricingParams } from '../../models';

export const normalizeCreateContractPricing = ({ contractKey, pricing }: LinkPricingParams): LinkPricingApi[] =>
  pricing.map(({ pricingKey }) => ({ contractKey, pricingId: pricingKey }));
